import React from "react";
import { siteSound } from "./consts";

export const playSound = (play) => {
  const localSound = window.localStorage.getItem("sounds");

  if (localSound === siteSound.ON) {
    return play();
  }
};